import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,

} from "reactstrap";


const defaultValue = {
    invoiceNo: '',
    referenceNo: '',
    date: new Date().toISOString(),
    dueDate: '',
    customerName: '',
    customerVatNo: '',
    postalAddress: '',
    physicalAddress: '',
    items: [
        {
            item: '',
            unitPrice: 0,
            quantity: 0,
            discount: 0,
            vat: 0,
            total: 0,
        }
    ],
    totalAmount: 0,
};


//Import Breadcrumb
import { addInvoice, countInvoices, getLab } from "service/api";

const Invoice = () => {
    const [Invoice, setInvoice] = useState(defaultValue)
    const [labOrder, setgetLab] = useState([])
    const [total, setTotal] = useState('0.00')
    const [formRows, setFormRows] = useState([{ id: 1, unitPrice: '', quantity: '', discount: '', vat: '', total: '0.00' }]);
    const [errors, setErrors] = useState({});


    const onAddFormRow = () => {
        const newRow = {
            id: formRows.length + 1,
            unitPrice: '',
            quantity: '',
            discount: '',
            vat: '',
            total: '0.00'
        };
        setFormRows([...formRows, newRow]);
    };

    const onDeleteFormRow = (id) => {
        if (id !== 1) {
            // Delete the row
            const newRows = formRows.filter(row => row.id !== id);
            setFormRows(newRows);

            // Recalculate the total after deletion
            const newTotal = newRows.reduce((acc, row) => acc + parseFloat(row.total), 0);
            setTotal(newTotal.toFixed(2));
        }
    };

    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setInvoice((prevState) => ({
            ...prevState,
            date: today,
        }));

        getLabAll()
        generateInvoiceNo();
    }, [])

    const getLabAll = async () => {
        let response = await getLab();
        setgetLab(response.data);
        console.log(response.data);
    }

    const generateInvoiceNo = async () => {
        try {
            // Fetch the count of invoices
            const response = await countInvoices();
            const count = response?.data?.count || 0;

            // Get the current date in the desired format (e.g., 20241224)
            const today = new Date();
            const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "").slice(2);

            // Generate the invoice number
            const invoiceNo = `INV${formattedDate}${count + 1}`;

            // Set the invoice number in the state
            setInvoice((prevState) => ({
                ...prevState,
                invoiceNo,
            }));
        } catch (error) {
            console.error("Error generating invoice number:", error);
        }
    };
    const onValueChange = (e, rowId) => {
        const { name, value } = e.target;

        if (rowId !== undefined) {
            // Update a specific row
            setFormRows(prevState => {
                const updatedRows = prevState.map(row => {
                    if (row.id === rowId) {
                        // Calculate total for the updated row based on the changed field
                        return { ...row, [name]: value, total: calculateRowTotal(row, name, value) };
                    }
                    return row;
                });
                // Recalculate total for all rows using updatedRows
                const newTotal = updatedRows.reduce((acc, row) => acc + parseFloat(row.total || 0), 0);
                setTotal(newTotal.toFixed(2)); // Update grand total state with 2 decimal points
                return updatedRows;
            });
        } else {
            // Update the Invoice state
            setInvoice(prevState => {
                const updatedInvoice = { ...prevState, [name]: value };
                // Calculate total if all required fields are present
                const { unitPrice, quantity, discount, vat } = updatedInvoice;
                let total = 0;
                if (unitPrice && quantity) {
                    const price = parseFloat(unitPrice) * parseInt(quantity);
                    const discountAmount = discount ? (price * parseFloat(discount)) / 100 : 0;
                    const vatAmount = vat ? ((price - discountAmount) * parseFloat(vat)) / 100 : 0;
                    total = price - discountAmount + vatAmount;
                }
                setTotal(total.toFixed(2)); // Update total state with 2 decimal points
                return updatedInvoice;
            });
        }
    };
    const calculateRowTotal = (row, name, value) => {
        const updatedRow = { ...row, [name]: value };
        const { unitPrice, quantity, discount, vat } = updatedRow;

        // Calculate the base price (unit price * quantity)
        let price = parseFloat(unitPrice || 0) * parseInt(quantity || 0);

        // Calculate discount amount if discount percentage is provided
        const discountAmount = discount ? (price * parseFloat(discount)) / 100 : 0;

        // Subtract discount from the price
        const priceAfterDiscount = price - discountAmount;

        // Calculate VAT amount if VAT percentage is provided
        const vatAmount = vat ? (priceAfterDiscount * parseFloat(vat)) / 100 : 0;

        // Final total: price after discount + VAT
        const total = priceAfterDiscount + vatAmount;

        // Return total rounded to 2 decimal places
        return total.toFixed(2);
    };

    const validate = () => {
        let errors = {};
        if (!Invoice.invoiceNo) errors.referenceNo = "invoice No. is required";
        if (!Invoice.referenceNo) errors.referenceNo = "Reference No. is required";
        if (!Invoice.dueDate) errors.dueDate = "Due Date is required";
        if (!Invoice.customerName) errors.customerName = "Customer Name is required";
        if (!Invoice.customerVatNo) errors.customerVatNo = "Customer VAT No. is required";
        if (!Invoice.postalAddress) errors.postalAddress = "Postal Address is required";
        if (!Invoice.physicalAddress) errors.physicalAddress = "Physical Address is required";

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const navigate = useNavigate();

    const addInvoiceDetails = async (e) => {
        e.preventDefault();
        if (validate()) {

            const invoiceData = {
                ...Invoice,
                items: formRows,
            };
            await addInvoice(invoiceData);
            navigate('/List/Invoice')
        }
    };


    //meta title
    document.title = "INVOICE | Form";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">Create Invoice</h4>
                        <Link to="/List/Invoice" className="btn btn-danger">Invoice List</Link>

                    </div>
                    {/* Render Breadcrumbs */}
                    {/* <Breadcrumbs title="Setting" breadcrumbItem="ADD COUNTRY" /> */}
                    <Row>
                        <Card>
                            <CardBody>
                                <CardTitle className="mb-4"></CardTitle>
                                <Form className="p-2" style={{ border: "0.5px solid #ddd", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>
                                    <Row>
                                        <Col
                                            md={6}
                                            style={{
                                                borderRight: "15px solid #ffff", // Adjust thickness and color here
                                                paddingRight: "10px",
                                                borderImage: "linear-gradient(to bottom, #ffff, #ffff) 1", // Optional gradient effect
                                            }}
                                        >
                                            <div className="mb-4">
                                                <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a" }}>Invoice Details</h4>
                                            </div>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-invoiceNo" style={{ fontWeight: "bold" }}>
                                                            Invoice No.
                                                        </Label>
                                                        <Input type="text" className="form-control" value={Invoice.invoiceNo} readOnly name="invoiceNo" onChange={(e) => onValueChange(e)} />
                                                        {errors.invoiceNo && <div className="text-danger">{errors.invoiceNo}</div>}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-referenceNo" style={{ fontWeight: "bold" }}>
                                                            Reference No.
                                                        </Label>
                                                        <select name="referenceNo" className="form-control" onChange={(e) => onValueChange(e)}>
                                                            <option defaultValue>Choose...</option>
                                                            {labOrder.map((lab) => (
                                                                <option key={lab._id} value={lab._id}>
                                                                    {lab?.patient_id?.reference}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.referenceNo && <div className="text-danger">{errors.referenceNo}</div>}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-date" style={{ fontWeight: "bold" }}>
                                                            Date
                                                        </Label>
                                                        <Input type="date" value={Invoice.date} className="form-control" name="date" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-dueDate" style={{ fontWeight: "bold" }}>
                                                            Due Date
                                                        </Label>
                                                        <Input type="date" className="form-control" name="dueDate" onChange={(e) => onValueChange(e)} />
                                                        {errors.dueDate && <div className="text-danger">{errors.dueDate}</div>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={6} style={{ paddingLeft: "20px" }}>
                                            <div className="mb-4">
                                                <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a" }}>Customer Details</h4>
                                            </div>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-customerName" style={{ fontWeight: "bold" }}>
                                                            Customer
                                                        </Label>
                                                        <Input type="text" className="form-control" name="customerName" onChange={(e) => onValueChange(e)} />
                                                        {errors.customerName && <div className="text-danger">{errors.customerName}</div>}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-customerVAT" style={{ fontWeight: "bold" }}>
                                                            Customer VAT No.
                                                        </Label>
                                                        <Input type="text" className="form-control" name="customerVatNo" onChange={(e) => onValueChange(e)} />
                                                        {errors.customerVatNo && <div className="text-danger">{errors.customerVatNo}</div>}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-postalAddress" style={{ fontWeight: "bold" }}>
                                                            Postal Address
                                                        </Label>
                                                        <Input type="textarea" rows="2" className="form-control" name="postalAddress" onChange={(e) => onValueChange(e)} />
                                                        {errors.postalAddress && <div className="text-danger">{errors.postalAddress}</div>}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-physicalAddress" style={{ fontWeight: "bold" }}>
                                                            Physical Address
                                                        </Label>
                                                        <Input type="textarea" rows="2" className="form-control" name="physicalAddress" onChange={(e) => onValueChange(e)} />
                                                        {errors.physicalAddress && <div className="text-danger">{errors.physicalAddress}</div>}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>


                                    <div className="mb-4">
                                        <h4 style={{ fontWeight: "bold", textAlign: "left", color: "#f46a6a" }}>Item Details</h4>
                                    </div>
                                    {(formRows || []).map((formRow, key) => (
                                        <Row key={formRow.id}>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Item</Label>
                                                    <Input type="text" className="form-control" name="item" onChange={(e) => onValueChange(e, formRow.id)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-item" style={{ fontWeight: "bold" }}>Unit Price</Label>
                                                    <Input type="text" className="form-control" name="unitPrice" onChange={(e) => onValueChange(e, formRow.id)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-quantity" style={{ fontWeight: "bold" }}>Quantity</Label>
                                                    <Input type="text" className="form-control" name="quantity" onChange={(e) => onValueChange(e, formRow.id)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-discount" style={{ fontWeight: "bold" }}>Discount(%)</Label>
                                                    <Input type="text" className="form-control" placeholder="%" name="discount" onChange={(e) => onValueChange(e, formRow.id)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-vat" style={{ fontWeight: "bold" }}>VAT(%)</Label>
                                                    <Input type="text" className="form-control" placeholder="%" name="vat" onChange={(e) => onValueChange(e, formRow.id)} />
                                                </div>
                                            </Col>
                                            <Col md={1} className="align-self-center">
                                                <div className="d-grid">
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary"
                                                        value="Delete"
                                                        onClick={() => onDeleteFormRow(formRow.id)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Row>
                                        <Col md={12} className="text-end">
                                            <Button color="success" onClick={onAddFormRow}>Add Item</Button>
                                        </Col>
                                    </Row>

                                    <hr style={{ border: "2px solid #555", backgroundColor: "#555", margin: "20px 0", opacity: "0.8" }} />

                                    <Row className="align-items-center">
                                        <Col md={10} className="text-end mt-2" >
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-total" style={{ fontWeight: "bold", color: "#555", marginBottom: "0" }}>
                                                    <h2 style={{ margin: "0", fontWeight: "bold" }}>Total:</h2>
                                                </Label>
                                            </div>
                                        </Col>
                                        <Col md={2} className="text-end">
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    textAlign: "right",
                                                    fontSize: "16px",
                                                    color: "#333",
                                                    borderBottom: "2px solid #555", // Underline effect
                                                    display: "inline-block",        // Ensures proper alignment
                                                    paddingBottom: "5px",          // Adds space between text and underline
                                                    width: "100%",                 // Full-width underline
                                                }}
                                            >
                                                {total}
                                            </div>
                                        </Col>

                                    </Row>

                                    <div className="mt-2 text-end">
                                        <button className="btn btn-success w-md mx-2" onClick={(e) => addInvoiceDetails(e)}>Save</button>
                                    </div>
                                </Form>

                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Invoice
